import { render, staticRenderFns } from "./PlanCanceled.vue?vue&type=template&id=72055ffc&scoped=true"
import script from "./PlanCanceled.vue?vue&type=script&lang=js"
export * from "./PlanCanceled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72055ffc",
  null
  
)

export default component.exports